import React, {useState, useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import MovieCard from './MovieCard';
import {Grid, Skeleton} from '@mui/material';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import '../MovieRow/style.css';
import Tmdb from '../../lib/Tmdb';
import { useInView } from 'react-intersection-observer';


const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
      slidesToSlide: 2, // optional, default to 1.
      partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.

    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

const MovieRow = ({category}) =>{

  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0.5,
    triggerOnce: true,
    initialInView:false,

  });

  const [categoryDataToTake,setCategoryDataToTake] = useState(category)
  const [movieData, setMovieData] = useState(null);

  useEffect(()=>{
    const loadData = async () =>{
      let data = await Tmdb.getHomelist(categoryDataToTake,'1');
      setMovieData(data);
    }
    loadData();
  }, [inView]);
    return(
      <>
        {movieData != null  ?
            <>
            {movieData.items.results.length > 0 ?(
                <>
                    <Grid container paddingTop={4} paddingBottom={0} sx={{display:"block"}} >
                    <Link to={`/FullCategory/${category}`} style={{textDecoration:"none"}}>
                        <h2 className='title'>{movieData.title} </h2>
                        <p style={{marginLeft:"3%",fontWeight:"light", fontSize:"1rem", color:"#fff" }}>Ver todos</p>
                        </Link>
                    </Grid>
                    <div ref={ref}>
                      {inView==true?
                       <Carousel
                       partialVisible={true}
                       swipeable={true}
                       draggable={true}
                       showDots={false}
                       responsive={responsive}
                       ssr={false} // means to render carousel on server-side.
                       infinite={true}
                       autoPlay={false}
                       keyBoardControl={true}
                       customTransition="transform 300ms ease-in-out"
                       transitionDuration={300}
                       containerClass="carousel-container"
                       dotListClass="custom-dot-list-style"
                       itemClass="carousel-item-padding-40-px"
                       className='customer-carousel'
                     >
                       {movieData.items.results.map((item,key)=>(
                           <MovieCard key={key} item={item}/>
                       ))} 
                       </Carousel>
                      :
                      <Skeleton animation="wave" sx={{ bgcolor: '#ffffff0f', borderRadius:"18px", margin:"auto", marginTop:"3rem" }} variant="rect" width={'95%'} height={'40vh'} />
                      }
                    </div>
                    
                   
                </>
            ):(
                <></>
            )}
            </>
        :
        <></>
        }
      </>
    );
    
}

export default MovieRow